// @flow
import React from 'react';
import { Link } from 'react-router-dom';
import { MdSortByAlpha, MdWhatshot } from 'react-icons/md';

import cx from 'classnames';
import './SearchTab.scss';

type Props = {
  menu: ?string,
  q: string,
};

const SearchTab = ({ menu, q }: Props) => (
  <div className="SearchTab">
    <Link className={cx({ active: menu === 'products' })} to={`/search?q=${q}&menu=products`}>
      <MdSortByAlpha />
      상품
    </Link>
    <Link className={cx({ active: menu === 'posts' })} to={`/search?q=${q}&menu=posts`}>
      <MdWhatshot />
      포스트
    </Link>
  </div>
);

SearchTab.defaultProps = {
  q: '',
  menu: '',
};

export default SearchTab;



// WEBPACK FOOTER //
// ./src/components/search/SearchTab/SearchTab.js